export function getLabelInfo(
  keyValues: string[] = [],
  data: Record<string, any>
) {
  if (typeof data !== 'object') return '';

  const fullLabel = Object.entries(data)
    .filter(([key, value]) => keyValues.includes(key) && value)
    .map(([_, value]) => value)
    .filter((str, index, self) => self.indexOf(str) === index) // remove repeated values
    .join(', ');

  return fullLabel;
}
